
export default function Services() {
  const services = [
    {
      title: 'LLC & Company Formation',
      description: 'Complete US & UK business registration, name changes, filings, EINs, and CAGE codes. We handle all the paperwork.',
      icon: 'ri-building-line',
      bgStyle: 'bg-[#1A2B3C]',
      textStyle: 'text-white',
      iconBg: 'bg-[#D4AF37]'
    },
    {
      title: 'Government Contracting',
      description: 'End-to-end support from SAM.gov registration to contract opportunities. NAICS codes, capability statements, and compliance.',
      icon: 'ri-government-line',
      bgImage: 'https://public.readdy.ai/ai/img_res/578835b77a1e1a33e90d11f2b6175fe5.jpg',
      badge: 'Most Popular',
      textStyle: 'text-white'
    },
    {
      title: 'Tax Services',
      description: 'Expert US & UK business and personal tax guidance, preparation, filing, and strategic planning to maximize savings.',
      icon: 'ri-calculator-line',
      bgStyle: 'bg-white border border-gray-200',
      textStyle: 'text-[#1A2B3C]',
      iconColor: 'text-[#1A2B3C]',
      numberStyle: 'text-[100px] font-bold text-[#D4AF37]/10 absolute top-4 right-4'
    },
    {
      title: 'HACCP Plan Preparation',
      description: 'Comprehensive Hazard Analysis Critical Control Point plans for food businesses to ensure safety compliance.',
      icon: 'ri-file-list-3-line',
      bgStyle: 'bg-gradient-to-br from-[#F8F6F3] to-white border border-gray-200',
      textStyle: 'text-[#1A2B3C]',
      iconBg: 'bg-[#1A2B3C]'
    },
    {
      title: 'Business Compliance & Licensing',
      description: 'Ensure your business meets all legal and regulatory requirements with our comprehensive compliance services.',
      icon: 'ri-shield-check-line',
      bgStyle: 'bg-white border border-gray-200',
      textStyle: 'text-[#1A2B3C]',
      iconBg: 'bg-[#D4AF37]'
    },
    {
      title: 'Business Advisory & Training',
      description: 'Strategic planning, process setup, operational guidance, and team training for startups and SMEs.',
      icon: 'ri-lightbulb-line',
      bgStyle: 'bg-[#1A2B3C]',
      textStyle: 'text-white',
      iconBg: 'bg-[#D4AF37]'
    }
  ];

  return (
    <section id="services" className="py-24 bg-[#F8F6F3]">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="flex items-end justify-between mb-16">
          <div>
            <div className="text-[#D4AF37] text-[13px] font-bold uppercase tracking-wider mb-3">OUR EXPERTISE</div>
            <h2 className="font-['Playfair_Display',serif] text-[48px] font-bold text-[#1A2B3C] leading-tight">
              Comprehensive Business<br />Solutions
            </h2>
          </div>
          <div className="flex gap-12">
            <div>
              <div className="text-[42px] font-bold text-[#1A2B3C]">500+</div>
              <div className="text-[14px] text-gray-600">Successful Projects</div>
            </div>
            <div>
              <div className="text-[42px] font-bold text-[#1A2B3C]">15+</div>
              <div className="text-[14px] text-gray-600">Years Experience</div>
            </div>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div 
              key={index}
              className={`${service.bgStyle} rounded-2xl p-8 hover:scale-[1.02] transition-all duration-300 cursor-pointer relative overflow-hidden group`}
              style={service.bgImage ? {
                backgroundImage: `url(${service.bgImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              } : {}}
            >
              {service.bgImage && <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/50 to-black/30"></div>}
              
              <div className="relative z-10">
                {service.badge && (
                  <div className="inline-block bg-[#D4AF37] text-[#1A2B3C] text-[11px] font-bold px-3 py-1 rounded-full mb-4">
                    {service.badge}
                  </div>
                )}
                
                {service.numberStyle && (
                  <div className={service.numberStyle}>0{index + 1}</div>
                )}
                
                <div className={`w-14 h-14 ${service.iconBg || 'bg-white/20'} rounded-xl flex items-center justify-center mb-5`}>
                  <i className={`${service.icon} text-2xl ${service.iconColor || 'text-white'}`}></i>
                </div>
                
                <h3 className={`text-[22px] font-bold ${service.textStyle} mb-3`}>
                  {service.title}
                </h3>
                
                <p className={`text-[14px] ${service.textStyle === 'text-white' ? 'text-gray-200' : 'text-gray-600'} leading-relaxed mb-4`}>
                  {service.description}
                </p>
                
                <div className={`flex items-center gap-2 text-[14px] font-semibold ${service.textStyle === 'text-white' ? 'text-[#D4AF37]' : 'text-[#1A2B3C]'} group-hover:gap-3 transition-all cursor-pointer`}>
                  Learn More <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
